import { render } from "./AccountDeleteModal.vue?vue&type=template&id=96b0bad2&scoped=true&ts=true"
import script from "./AccountDeleteModal.vue?vue&type=script&lang=ts"
export * from "./AccountDeleteModal.vue?vue&type=script&lang=ts"

import "./AccountDeleteModal.vue?vue&type=style&index=0&id=96b0bad2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b0bad2"]])

export default __exports__